<div class="flex flex-column gap-2">
    <div class="flex align-items-center gap-1">
        <p-button [icon]="thumbUpActive ? 'pi pi-thumbs-up-fill' : 'pi pi-thumbs-up'" size="small" [text]="true"
            [rounded]="true" [severity]="thumbUpActive ? undefined : 'secondary'" [disabled]="readonly || saving"
            [pTooltip]="thumbUpActive ? 'Retirer mon avis' : 'Réponse utile'" tooltipPosition="bottom"
            ariaLabel="Réponse utile" (onClick)="onClickThumbUp()"></p-button>
        <p-button [icon]="thumbDownActive ? 'pi pi-thumbs-down-fill' : 'pi pi-thumbs-down'" size="small" [text]="true"
            [rounded]="true" [severity]="thumbDownActive ? undefined : 'secondary'" [disabled]="readonly || saving"
            [pTooltip]="feedback === 'negative' ? 'Modifier mon commentaire' : 'Réponse à améliorer'" tooltipPosition="bottom"
            ariaLabel="Réponse à améliorer" (onClick)="onClickThumbDown()"></p-button>
    </div>

    @if (readonly && feedback === 'negative' && feedbackComment) {
    <!-- Supervision : le commentaire de l'avis négatif se lit, il ne se modifie pas -->
    <div class="text-sm text-color-secondary font-italic">« {{ feedbackComment }} »</div>
    }

    @if (editing) {
    <div class="flex flex-column gap-2">
        <textarea pTextarea [(ngModel)]="draft" rows="3" [maxLength]="commentMaxLength" [autoResize]="true"
            class="w-full text-sm" placeholder="Qu'est-ce qui n'allait pas dans cette réponse ?"
            [disabled]="saving"></textarea>
        <div class="flex align-items-center justify-content-between gap-2">
            @if (feedback === 'negative') {
            <p-button label="Retirer mon avis" size="small" severity="secondary" [text]="true" [rounded]="true"
                [disabled]="saving" (onClick)="onClickRemove()"></p-button>
            } @else {
            <span></span>
            }
            <div class="flex gap-2">
                <p-button label="Annuler" size="small" severity="secondary" [text]="true" [rounded]="true"
                    [disabled]="saving" (onClick)="onClickCancel()"></p-button>
                <p-button label="Envoyer" size="small" [rounded]="true" [disabled]="!draft.trim()" [loading]="saving"
                    (onClick)="onClickSend()"></p-button>
            </div>
        </div>
    </div>
    }
</div>
